import React from 'react';
import PropTypes from 'prop-types';
import cx from 'clsx';
import { CaretLeft, CaretRight } from '@nike/nike-design-system-icons';
import styles from './autoplayCarousel.styl';
import { THEMES } from '../../shapes';

export const NavigationButtons = React.memo(
  ({
    colorTheme = THEMES.LIGHT,
    onPrevClick,
    onNextClick,
    translations = {},
  }) => {
    const navButtonClasses = cx(styles.navButton, {
      [styles.dark]: colorTheme === THEMES.DARK,
    });

    return (
      <div className={styles.navBtnContainer}>
        <button
          className={navButtonClasses}
          aria-label={translations.prevButton || 'Previous slide'}
          onClick={onPrevClick}
          type="button"
          data-qa="prev-btn"
        >
          <CaretLeft className={styles.caret} aria-hidden="true" />
        </button>
        <button
          className={navButtonClasses}
          aria-label={translations.nextButton || 'Next slide'}
          onClick={onNextClick}
          type="button"
          data-qa="next-btn"
        >
          <CaretRight className={styles.caret} aria-hidden="true" />
        </button>
      </div>
    );
  },
);

NavigationButtons.displayName = 'NavigationButtons';

NavigationButtons.propTypes = {
  colorTheme: PropTypes.string,
  onNextClick: PropTypes.func.isRequired,
  onPrevClick: PropTypes.func.isRequired,
  translations: PropTypes.objectOf(PropTypes.string),
};
